<div class="container-fluid vertical-align-center">
  <div class="row">
    <div class="col-12">
      <img class="h-100px" src="../../../assets/under-construction-black.png" alt="" srcset="">
      <p class="fw-bold">This section is under development.</p>
      <p class="fs-12">It's not you it's us! Please stay in touch, this section will be available once developed.</p>
    </div>
  </div>
</div>
